import React from 'react';
import { RegistrationType } from '../../../enums/registration-type';
import { ClassicRegisterLayout } from './classic/classic.register.layout';
import { FreemiumRegisterLayout } from '../../freemium-feature/account/freemium/freemium.register.layout';
import { ErrorPage } from '../../error/error.page';
import { useAppState } from '../../../overmind';

export function RegisterPage(): JSX.Element {
  const { registrationType } = useAppState();
  if (registrationType === RegistrationType.Classic) {
    return <ClassicRegisterLayout></ClassicRegisterLayout>;
  } else if (registrationType === RegistrationType.Freemium) {
    return <FreemiumRegisterLayout></FreemiumRegisterLayout>;
  }
  return <ErrorPage />;
}
